const routes = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    meta: { needsAuth: true },
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('pages/IndexPage.vue'),
      },
      {
        path: 'food',
        name: 'FoodIndex',
        meta: { needsAdmin: true },
        component: () => import('pages/FoodIndex.vue'),
      },
      {
        path: 'food/:id',
        name: 'FoodView',
        meta: { needsAdmin: true },
        component: () => import('pages/FoodView.vue'),
      },
    ],
  },

  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    meta: { needsAuth: true },
    children: [
      {
        path: 'journal',
        name: 'JournalIndex',
        component: () => import('pages/JournalIndex.vue'),
      },
      {
        path: 'journal/create/:mealtime',
        name: 'JournalCreate',
        component: () => import('pages/JournalCreate.vue'),
      },
      {
        path: 'calculator',
        name: 'MacrosCalculator',
        component: () => import('pages/MacrosCalculatorIndex.vue'),
      },
      {
        path: 'meal',
        name: 'MealIndex',
        component: () => import('pages/MealIndex.vue'),
      },
      {
        path: 'recipe',
        name: 'RecipeIndex',
        component: () => import('pages/RecipeIndex.vue'),
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('pages/SettingsPage.vue'),
      },
      {
        path: 'evaluation',
        name: 'EvaluationIndex',
        component: () => import('pages/EvaluationIndex.vue'),
      },
      {
        path: 'page',
        name: 'PageIndex',
        component: () => import('pages/PageIndex.vue'),
      },
      {
        path: 'page/:id',
        name: 'PageView',
        component: () => import('pages/PageView.vue'),
      },
      {
        path: 'news',
        name: 'NewsIndex',
        component: () => import('pages/NewsIndex.vue'),
      },
      {
        path: 'news/:id',
        name: 'NewsView',
        component: () => import('pages/NewsView.vue'),
      },
    ],
  },

  {
    path: '/authentication',
    component: () => import('layouts/SimpleLayout.vue'),
    children: [
      {
        path: '',
        name: 'Authentication',
        component: () => import('pages/AuthenticationPage.vue'),
      },
      {
        path: 'registration',
        name: 'Registration',
        component: () => import('pages/RegistrationPage.vue'),
      },
      {
        path: 'resetPassword',
        name: 'ResetPassword',
        component: () => import('pages/ResetPasswordPage.vue'),
      },

    ],
  },

  {
    path: '/subscriptions',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        name: 'SubscriptionsIndex',
        component: () => import('pages/SubscriptionsIndex.vue'),
      },
      {
        path: 'expired',
        name: 'SubscriptionExpired',
        component: () => import('pages/SubscriptionExpired.vue'),
      },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
